// Feature flags for the 2Voto scope transition (2026-06).
// Incompatible modules are hidden from navigation and routing WITHOUT deleting
// code or data, so they can be reactivated after legal review if approved.
export const MODULES = {
  peticiones: false,
  fiscalizacion: false,
  promesometro: false,
  reporta: false,
  perfiles: false,
  biblioteca: false,
};

export const isEnabled = (key) => MODULES[key] === true;
